import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { Resolution886ReportService, } from '@/infra/services/resolution-886-report';

interface GetResolution886AttachmentsParams {
	organization_id: string,
	company_id: string,
	report_id: string,
	review_id: string,
	assessment_id: string,
	category_result_id: string
}

const Service = Resolution886ReportService.getInstance();

function isEnabled(params: GetResolution886AttachmentsParams): boolean {
	return (
		!!params.organization_id &&
		!!params.company_id &&
		!!params.report_id &&
		!!params.review_id &&
		!!params.assessment_id &&
		!!params.category_result_id
	);
}

export function useGetResolution886Attachments(params: GetResolution886AttachmentsParams) {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_RESOLUTION_886_ASSESSMENT_ATTACHMENT_LIST, params],
		queryFn: () => Service.getAttachments(params),
		enabled: isEnabled(params)
	});
}
